import { GridSortModel } from '@mui/x-data-grid';
import { backendServices, orderBy } from '../../../services';
import { calculatePageOffset } from '../../../utils';
import { RoleTypeGridItem } from './types';

export class RoleTypeService {
    private api = new backendServices.Apis.RoleTypeApi();

    public async getRoleTypeGridItems(
        pageSize: number,
        pageNumber: number,
        sortModel: GridSortModel,
        $filter?: string
    ) {
        const $orderBy = orderBy(sortModel) || 'ID desc';
        const response = await this.api.getRoleTypes({
            $top: pageSize,
            $skip: calculatePageOffset(pageSize, pageNumber),
            $count: true,
            $orderBy,
            $filter,
        });
        return {
            count: response.data.Count || 0,
            items: response.data.Items.map(this.mapRoleTypeGridItem),
        };
    }

    private mapRoleTypeGridItem = (role: backendServices.ViewModels.RoleTypeViewModel): RoleTypeGridItem => {
        if (role.ID == null) {
            throw new Error('Expected roleType.Id to be non-null');
        }

        return {
            id: role.ID,
            name: role.Name,
            description: role.Description,
            companyId: role.CompanyId,
        };
    };
}
